import { Input, Radio } from '@material-tailwind/react'
import React from 'react'
import AutocompleteInput from './AutocompleteInput'
import { PencilIcon } from '@heroicons/react/20/solid'
import AutocompleteUser from '../ManageWarehouse/AutocompleteUser'

const ShipmentDetails = ({ step, setStep, dimension, setDimension, dimentionData, setDimentionData, subOrders, setSubOrders, dropLocation, setDropLocation, mode, setMode, shippingType, setShippingType, amount, setAmount, weight, setWeight, consigneeGST, setConsigneeGST, sellerGST, setSellerGST, orderID, setOrderID, lrDetails, setLrDetails, lrNumber, setLrNumber, warehouseList, pickupLocation, setPickupLocation, userList, user, setUser, orderList, setTotalbox, totalbox, createdAtInput, setCreatedAtInput }) => {
  return (
    <div className='rounded-[28px] border border-slate-200 bg-white px-5 py-5 shadow-[0_18px_42px_rgba(15,23,42,0.07)] lg:px-6'>
      <div className='mb-6 flex flex-col gap-1 border-b border-slate-100 pb-5'>
        <div className='flex items-center gap-3'>
          <div className='flex h-10 w-10 items-center justify-center rounded-2xl bg-[#fff4ed] text-sm font-[GilroyBold] text-[#c2410c]'>01</div>
          <div>
            <h4 className='font-[GilroyBold] text-[1.15rem] text-slate-900'>Shipment details</h4>
            <p className='text-sm font-[GilroyMedium] text-slate-500'>Choose the client, pickup warehouse, and shipment metadata.</p>
          </div>
        </div>
      </div>
      <div className='space-y-6'>
        <div className='rounded-[24px] border border-slate-200 bg-slate-50/70 p-4'>
          <div className='mb-4'>
            <h4 className='text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>LR configuration</h4>
            <p className='mt-1 text-sm text-slate-500'>Decide whether the LR number is entered by operations or generated from the order flow.</p>
          </div>
          <div className='grid gap-3 md:grid-cols-2'>
            <button
              type='button'
              onClick={() => setLrDetails('manual')}
              className={`rounded-[22px] border px-4 py-4 text-left transition-all ${
                lrDetails === 'manual' ? 'border-[#fdba74] bg-white shadow-[0_12px_24px_rgba(249,115,22,0.08)]' : 'border-slate-200 bg-white'
              }`}
            >
              <p className='text-sm font-[GilroyBold] text-slate-900'>Manual LR number</p>
              <p className='mt-1 text-xs leading-5 text-slate-500'>Enter the shipment LR yourself before booking.</p>
            </button>
            <button
              type='button'
              onClick={() => setLrDetails('automatic')}
              className={`rounded-[22px] border px-4 py-4 text-left transition-all ${
                lrDetails === 'automatic' ? 'border-[#fdba74] bg-white shadow-[0_12px_24px_rgba(249,115,22,0.08)]' : 'border-slate-200 bg-white'
              }`}
            >
              <p className='text-sm font-[GilroyBold] text-slate-900'>Automatic LR number</p>
              <p className='mt-1 text-xs leading-5 text-slate-500'>Let the system generate LR while keeping order flow faster.</p>
            </button>
          </div>
          <div className='mt-4 max-w-[460px]'>
            <Input value={lrNumber} onChange={(e) => setLrNumber(e.target.value)} disabled={lrDetails === "automatic"} label='Enter LR No' />
          </div>
        </div>

        <div className='rounded-[24px] border border-slate-200 bg-white p-1'>
          <div className='mb-4 px-3 pt-3'>
            <h4 className='text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Operational inputs</h4>
          </div>
          <div className='grid gap-4 p-3 xl:grid-cols-3'>
            <div className='min-w-0'>
              {Object.keys(user).length === 0 ? <AutocompleteUser selected={user} setSelected={setUser} placeholder="Search client" data={userList} /> : <div className='rounded-[22px] border border-slate-200 bg-slate-50 px-4 py-4'>
                <div className='mb-3 flex items-center justify-between'>
                  <p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Selected client</p>
                  <PencilIcon className='w-[18px] cursor-pointer text-slate-500' onClick={() => setUser({})} />
                </div>
                <h3 className='text-[13px] font-[GilroyBold] text-slate-900'>{user.name}, {user.email}</h3>
                <h3 className='mt-1 text-[12px] font-[GilroyMedium] text-slate-500'>{user.companyName}</h3>
              </div>}
            </div>
            <div className='min-w-0'>
              {Object.keys(pickupLocation).length === 0 ? <AutocompleteInput selected={pickupLocation} setSelected={setPickupLocation} placeholder="Search pickup location" data={warehouseList} /> : <div className='rounded-[22px] border border-slate-200 bg-slate-50 px-4 py-4'>
                <div className='mb-3 flex items-center justify-between'>
                  <p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Pickup location</p>
                  <PencilIcon className='w-[18px] cursor-pointer text-slate-500' onClick={() => setPickupLocation({})} />
                </div>
                <h3 className='text-[13px] font-[GilroyBold] text-slate-900'>{pickupLocation?.pickupName?.name}, {pickupLocation.pinCode}</h3>
                <h3 className='mt-1 text-[12px] font-[GilroyMedium] text-slate-500'>{pickupLocation.address}, {pickupLocation.city}, {pickupLocation.state}</h3>
              </div>}
            </div>
            <div className='min-w-0'>
              <Input value={weight} onChange={(e) => setWeight(e.target.value)} label='Enter Total Weight(in Kg)' />
            </div>
            <div className='min-w-0'>
              <Input value={orderID} onChange={(e) => setOrderID(e.target.value)} label='Enter Order ID' />
            </div>
            <div className='min-w-0'>
              <div className='rounded-[22px] border border-slate-200 bg-white px-4 py-3 shadow-[0_8px_22px_rgba(15,23,42,0.04)]'>
                <p className='mb-3 text-[10px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Shipping Type</p>
                <div className='flex gap-5'>
                  <label className='flex items-center gap-2 text-sm font-[GilroyMedium] text-slate-700'>
                    <input
                      type='radio'
                      name='shipping-type'
                      value='LOC'
                      checked={shippingType === 'LOC'}
                      onChange={(e) => setShippingType(e.target.value)}
                    />
                    LOC
                  </label>
                  <label className='flex items-center gap-2 text-sm font-[GilroyMedium] text-slate-700'>
                    <input
                      type='radio'
                      name='shipping-type'
                      value='DOM'
                      checked={shippingType === 'DOM'}
                      onChange={(e) => setShippingType(e.target.value)}
                    />
                    DOM
                  </label>
                </div>
              </div>
            </div>
            <div className='min-w-0'>
              <Input
                type="date"
                value={createdAtInput}
                onChange={(e) => setCreatedAtInput(e.target.value)}
                label='Created At'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShipmentDetails
